import { FormInstance } from "antd/es/form";
import _ from "lodash";
import React from "react";
import { IUserInfoDto } from "../../models/dto/user-info.dto";
import { IValidationData } from "../../models/dto/validation-data";
import { UserService } from "../../services/user-service";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface ILeftMenu_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface ILeftMenu_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  GetGuidanceDoc: any[];
  GetGuidanceDoc_dummy: any[];
  DownloadFile: any;
  DownloadFile_dummy: any;
  Logout: boolean;
  Logout_dummy: boolean;
  goToSignInActivity: any;
  goToSignInActivity_dummy: any;
  isComp63815Visible: "visible" | "hidden";
  isComp901672Visible: "visible" | "hidden";
  isComp725468Visible: "visible" | "hidden";
  isComp15857Visible: "visible" | "hidden";
  isComp101896Visible: "visible" | "hidden";
  isComp368105Visible: "visible" | "hidden";
  isComp340202Visible: "visible" | "hidden";
  isComp553154Visible: "visible" | "hidden";
  isComp815895Visible: "visible" | "hidden";
  isComp957276Visible: "visible" | "hidden";
  isComp210732Visible: "visible" | "hidden";
  isComp861165Visible: "visible" | "hidden";
  isComp556414Visible: "visible" | "hidden";
  isComp122268Visible: "visible" | "hidden";
  isCompleftmenu_63815AuthorizationVisible: "visible" | "hidden";
  isCompleftmenu_901672AuthorizationVisible: "visible" | "hidden";
  isCompleftmenu_725468AuthorizationVisible: "visible" | "hidden";
  isCompleftmenu_15857AuthorizationVisible: "visible" | "hidden";
  isCompleftmenu_101896AuthorizationVisible: "visible" | "hidden";
  isCompleftmenu_368105AuthorizationVisible: "visible" | "hidden";
  isCompleftmenu_340202AuthorizationVisible: "visible" | "hidden";
  isCompleftmenu_553154AuthorizationVisible: "visible" | "hidden";
  isCompleftmenu_815895AuthorizationVisible: "visible" | "hidden";
  isCompleftmenu_957276AuthorizationVisible: "visible" | "hidden";
  isCompleftmenu_210732AuthorizationVisible: "visible" | "hidden";
  isCompleftmenu_861165AuthorizationVisible: "visible" | "hidden";
  isCompleftmenu_556414AuthorizationVisible: "visible" | "hidden";
  isCompleftmenu_741736AuthorizationVisible: "visible" | "hidden";
  isCompleftmenu_122268AuthorizationVisible: "visible" | "hidden";
  isCompleftmenu_734963AuthorizationVisible: "visible" | "hidden";
}

export class LeftMenu_ScreenBase extends React.PureComponent<
  ILeftMenu_ScreenProps,
  any
> {
  ml = [
    {
      Id: "782add75-a2c8-e698-bccf-af29bb1e9b35",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [
        {
          Id: 501123,
          PropertyName: "value",
          Value: "Menu",
          TagName: "lblTitle_value",
        },
        {
          Id: 188381,
          PropertyName: "value",
          Value: "Çıkış Yap",
          TagName: "lblLogout_value",
        },
        {
          Id: 444715,
          PropertyName: "value",
          Value: "Anasayfa",
          TagName: "Label8_value",
        },
        {
          Id: 509283,
          PropertyName: "value",
          Value: "Kullanıcı Bildirimi Oluştur",
          TagName: "Label11_value",
        },
        {
          Id: 335840,
          PropertyName: "value",
          Value: "Raporlar",
          TagName: "Label12_value",
        },
        {
          Id: 418566,
          PropertyName: "value",
          Value: "Anasayfa",
          TagName: "Label13_value",
        },
        {
          Id: 66896,
          PropertyName: "value",
          Value: "Koleksiyonlar",
          TagName: "Label14_value",
        },
        {
          Id: 882001,
          PropertyName: "value",
          Value: "Yan Doldurma",
          TagName: "Label16_value",
        },
        {
          Id: 795386,
          PropertyName: "value",
          Value: "Seri Sonu",
          TagName: "Label19_value",
        },
        {
          Id: 30709,
          PropertyName: "value",
          Value: "Hızlı Stok",
          TagName: "Label15_value",
        },
        {
          Id: 699736,
          PropertyName: "value",
          Value: "Raporlar",
          TagName: "Label21_value",
        },
        {
          Id: 565019,
          PropertyName: "value",
          Value: "Sepetim",
          TagName: "Label17_value",
        },
        {
          Id: 445619,
          PropertyName: "value",
          Value: "Favori Desenlerim",
          TagName: "Label22_value",
        },
        {
          Id: 791310,
          PropertyName: "value",
          Value: "Bildirimlerim",
          TagName: "Label20_value",
        },
        {
          Id: 513569,
          PropertyName: "value",
          Value: "Sosyal Medya",
          TagName: "Label18_value",
        },
        {
          Id: 499300,
          PropertyName: "value",
          Value: "Profilim",
          TagName: "Label23_value",
        },
        {
          Id: 736645,
          PropertyName: "value",
          Value: "Bilgi Dokümanı",
          TagName: "Label24_value",
        },
      ],
    },
    {
      Id: "c2176777-61f9-4e18-a818-fb50309cde20",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [
        {
          Id: 501123,
          PropertyName: "value",
          Value: "Menu",
          TagName: "lblTitle_value",
        },
        {
          Id: 444715,
          PropertyName: "value",
          Value: "Homepage",
          TagName: "Label8_value",
        },
        {
          Id: 509283,
          PropertyName: "value",
          Value: "Create User Notification",
          TagName: "Label11_value",
        },
        {
          Id: 335840,
          PropertyName: "value",
          Value: "Reports",
          TagName: "Label12_value",
        },
        {
          Id: 418566,
          PropertyName: "value",
          Value: "Homepage",
          TagName: "Label13_value",
        },
        {
          Id: 66896,
          PropertyName: "value",
          Value: "Collections",
          TagName: "Label14_value",
        },
        {
          Id: 882001,
          PropertyName: "value",
          Value: " Side Filling",
          TagName: "Label16_value",
        },
        {
          Id: 795386,
          PropertyName: "value",
          Value: "End of Series",
          TagName: "Label19_value",
        },
        {
          Id: 30709,
          PropertyName: "value",
          Value: "Quick Stock",
          TagName: "Label15_value",
        },
        {
          Id: 699736,
          PropertyName: "value",
          Value: "Reports",
          TagName: "Label21_value",
        },
        {
          Id: 565019,
          PropertyName: "value",
          Value: "My Basket",
          TagName: "Label17_value",
        },
        {
          Id: 445619,
          PropertyName: "value",
          Value: "Favorite Patterns",
          TagName: "Label22_value",
        },
        {
          Id: 791310,
          PropertyName: "value",
          Value: "Bildirimlerim",
          TagName: "Label20_value",
        },
        {
          Id: 513569,
          PropertyName: "value",
          Value: "Social Media",
          TagName: "Label18_value",
        },
        {
          Id: 499300,
          PropertyName: "value",
          Value: "Profile",
          TagName: "Label23_value",
        },
        {
          Id: 736645,
          PropertyName: "value",
          Value: "Information Document",
          TagName: "Label24_value",
        },
      ],
    },
    {
      Id: "0e7ac06a-40f2-45bf-9564-99ee9734a4dd",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 501123, PropertyName: "value", Value: "Menu" },
        { Id: 444715, PropertyName: "value", Value: "Anasayfa" },
        {
          Id: 509283,
          PropertyName: "value",
          Value: "Kullanıcı Bildirimi Oluştur",
        },
        { Id: 335840, PropertyName: "value", Value: "Raporlar" },
        { Id: 418566, PropertyName: "value", Value: "Anasayfa" },
        { Id: 66896, PropertyName: "value", Value: "Koleksiyonlar" },
        { Id: 882001, PropertyName: "value", Value: "Yan Doldurma" },
        { Id: 795386, PropertyName: "value", Value: "Seri Sonu" },
        { Id: 30709, PropertyName: "value", Value: "Hızlı Stok" },
        { Id: 699736, PropertyName: "value", Value: "Raporlar" },
        { Id: 565019, PropertyName: "value", Value: "Sepetim" },
        { Id: 445619, PropertyName: "value", Value: "Favori Desenlerim" },
        { Id: 791310, PropertyName: "value", Value: "Bildirimlerim" },
        { Id: 513569, PropertyName: "value", Value: "Sosyal Medya" },
        { Id: 499300, PropertyName: "value", Value: "Profilim" },
        { Id: 446147, PropertyName: "value", Value: "Çeviri/Translate" },
        { Id: 736645, PropertyName: "value", Value: "Bilgi Dokümanı" },
        { Id: 188381, PropertyName: "value", Value: "Çıkış Yap" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      NAVIGATE: "",
      GetGuidanceDoc: [],
      DownloadFile: "",
      Logout: false,
      goToSignInActivity: "",
      isComp63815Visible: "hidden",
      isComp901672Visible: "hidden",
      isComp725468Visible: "hidden",
      isComp15857Visible: "hidden",
      isComp101896Visible: "hidden",
      isComp368105Visible: "hidden",
      isComp340202Visible: "hidden",
      isComp553154Visible: "hidden",
      isComp815895Visible: "hidden",
      isComp957276Visible: "hidden",
      isComp210732Visible: "hidden",
      isComp861165Visible: "hidden",
      isComp556414Visible: "hidden",
      isComp122268Visible: "hidden",
      isCompleftmenu_63815AuthorizationVisible: "visible",
      isCompleftmenu_901672AuthorizationVisible: "visible",
      isCompleftmenu_725468AuthorizationVisible: "visible",
      isCompleftmenu_15857AuthorizationVisible: "visible",
      isCompleftmenu_101896AuthorizationVisible: "visible",
      isCompleftmenu_368105AuthorizationVisible: "visible",
      isCompleftmenu_340202AuthorizationVisible: "visible",
      isCompleftmenu_553154AuthorizationVisible: "visible",
      isCompleftmenu_815895AuthorizationVisible: "visible",
      isCompleftmenu_957276AuthorizationVisible: "visible",
      isCompleftmenu_210732AuthorizationVisible: "visible",
      isCompleftmenu_861165AuthorizationVisible: "visible",
      isCompleftmenu_556414AuthorizationVisible: "visible",
      isCompleftmenu_741736AuthorizationVisible: "visible",
      isCompleftmenu_122268AuthorizationVisible: "visible",
      isCompleftmenu_734963AuthorizationVisible: "visible",
    };

    this.CheckPageAuthorization(this.state);
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("leftmenu", "");
      return;
    }

    this.fillFormInitValues();
    if (true) {
      await this.LeftMenuPageInit();
    }
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenu_63815AuthorizationVisible",
      [
        "605fa807-9b13-e323-c2b5-2198b67672c4",
        "af27e181-8ee4-f93d-64a9-9e2b5e056d6c",
        "B2BAdmin",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenu_901672AuthorizationVisible",
      [
        "605fa807-9b13-e323-c2b5-2198b67672c4",
        "af27e181-8ee4-f93d-64a9-9e2b5e056d6c",
        "B2BAdmin",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenu_725468AuthorizationVisible",
      [
        "605fa807-9b13-e323-c2b5-2198b67672c4",
        "af27e181-8ee4-f93d-64a9-9e2b5e056d6c",
        "B2BAdmin",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenu_15857AuthorizationVisible",
      [
        "fcf2aa80-320a-e0a6-9e78-02d60a07cc52",
        "b0582dca-d15e-93c3-7cb1-20c8fd8b886a",
        "B2BCustomer",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenu_101896AuthorizationVisible",
      [
        "fcf2aa80-320a-e0a6-9e78-02d60a07cc52",
        "b0582dca-d15e-93c3-7cb1-20c8fd8b886a",
        "B2BCustomer",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenu_368105AuthorizationVisible",
      [
        "fcf2aa80-320a-e0a6-9e78-02d60a07cc52",
        "b0582dca-d15e-93c3-7cb1-20c8fd8b886a",
        "B2BCustomer",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenu_340202AuthorizationVisible",
      [
        "fcf2aa80-320a-e0a6-9e78-02d60a07cc52",
        "b0582dca-d15e-93c3-7cb1-20c8fd8b886a",
        "B2BCustomer",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenu_553154AuthorizationVisible",
      [
        "fcf2aa80-320a-e0a6-9e78-02d60a07cc52",
        "b0582dca-d15e-93c3-7cb1-20c8fd8b886a",
        "B2BCustomer",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenu_815895AuthorizationVisible",
      [
        "fcf2aa80-320a-e0a6-9e78-02d60a07cc52",
        "b0582dca-d15e-93c3-7cb1-20c8fd8b886a",
        "B2BCustomer",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenu_957276AuthorizationVisible",
      [
        "fcf2aa80-320a-e0a6-9e78-02d60a07cc52",
        "b0582dca-d15e-93c3-7cb1-20c8fd8b886a",
        "B2BCustomer",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenu_210732AuthorizationVisible",
      [
        "fcf2aa80-320a-e0a6-9e78-02d60a07cc52",
        "b0582dca-d15e-93c3-7cb1-20c8fd8b886a",
        "B2BCustomer",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenu_861165AuthorizationVisible",
      [
        "fcf2aa80-320a-e0a6-9e78-02d60a07cc52",
        "b0582dca-d15e-93c3-7cb1-20c8fd8b886a",
        "B2BCustomer",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenu_556414AuthorizationVisible",
      [
        "fcf2aa80-320a-e0a6-9e78-02d60a07cc52",
        "605fa807-9b13-e323-c2b5-2198b67672c4",
        "b0582dca-d15e-93c3-7cb1-20c8fd8b886a",
        "B2BCustomer",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenu_741736AuthorizationVisible",
      [
        "fcf2aa80-320a-e0a6-9e78-02d60a07cc52",
        "605fa807-9b13-e323-c2b5-2198b67672c4",
        "b0582dca-d15e-93c3-7cb1-20c8fd8b886a",
        "af27e181-8ee4-f93d-64a9-9e2b5e056d6c",
        "B2BCustomer",
        "B2BAdmin",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenu_122268AuthorizationVisible",
      [
        "fcf2aa80-320a-e0a6-9e78-02d60a07cc52",
        "605fa807-9b13-e323-c2b5-2198b67672c4",
        "b0582dca-d15e-93c3-7cb1-20c8fd8b886a",
        "af27e181-8ee4-f93d-64a9-9e2b5e056d6c",
        "B2BCustomer",
        "B2BAdmin",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenu_734963AuthorizationVisible",
      [
        "fcf2aa80-320a-e0a6-9e78-02d60a07cc52",
        "605fa807-9b13-e323-c2b5-2198b67672c4",
        "b0582dca-d15e-93c3-7cb1-20c8fd8b886a",
        "af27e181-8ee4-f93d-64a9-9e2b5e056d6c",
        "B2BCustomer",
        "B2BAdmin",
      ]
    );

    KuikaAppManager.calculateAndSetBodyHeight("leftmenu", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  CheckPageAuthorization = async (state) => {
    KuikaAppManager.showSpinner(this);
    if (_.isEmpty(window.userInfo)) {
      await UserService.GetUserInfoForce();
    }
    const permittedRoleNames: string[] = ["B2BCustomer", "B2BAdmin"];
    const userInfo = window.userInfo as IUserInfoDto;
    const userRoleNames = userInfo.roles.map((role) => role.name);
    if (
      !permittedRoleNames.some((roleName) => userRoleNames.includes(roleName))
    ) {
      await ReactSystemFunctions.goBack(this);

      const language = localStorage.getItem("ml");
      let permissonErrorMessageText =
        "You do not have permission to access this page.";
      if (language === "tr_TR") {
        permissonErrorMessageText = "Bu sayfaya erişim yetkiniz yok.";
      } else if (language === "fr_FR") {
        permissonErrorMessageText =
          "Vous n'avez pas la permission d'accéder à cette page.";
      } else if (language === "de_DE") {
        permissonErrorMessageText =
          "Sie haben keine Berechtigung, auf diese Seite zuzugreifen.";
      } else if (language === "es_ES") {
        permissonErrorMessageText =
          "No tienes permiso para acceder a esta página.";
      }

      KMainFunctions.displayErrorNotification(permissonErrorMessageText);
      state.isPageVisible = false;
      KuikaAppManager.hideSpinner(this);
      return;
    }
    state.isPageVisible = true;
    KuikaAppManager.hideSpinner(this);
  };

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("leftmenu", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.LeftMenuPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  LeftMenuPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.isComp63815Visible =
      ReactSystemFunctions.contains(
        ReactSystemFunctions.getMyRoleNames(),
        "B2BAdmin"
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp901672Visible =
      ReactSystemFunctions.contains(
        ReactSystemFunctions.getMyRoleNames(),
        "B2BAdmin"
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp725468Visible =
      ReactSystemFunctions.contains(
        ReactSystemFunctions.getMyRoleNames(),
        "B2BAdmin"
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp15857Visible =
      ReactSystemFunctions.contains(
        ReactSystemFunctions.getMyRoleNames(),
        "B2BCustomer"
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp101896Visible =
      ReactSystemFunctions.contains(
        ReactSystemFunctions.getMyRoleNames(),
        "B2BCustomer"
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp368105Visible =
      ReactSystemFunctions.contains(
        ReactSystemFunctions.getMyRoleNames(),
        "B2BCustomer"
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp340202Visible =
      ReactSystemFunctions.contains(
        ReactSystemFunctions.getMyRoleNames(),
        "B2BCustomer"
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp553154Visible =
      ReactSystemFunctions.contains(
        ReactSystemFunctions.getMyRoleNames(),
        "B2BCustomer"
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp815895Visible =
      ReactSystemFunctions.contains(
        ReactSystemFunctions.getMyRoleNames(),
        "B2BCustomer"
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp957276Visible =
      ReactSystemFunctions.contains(
        ReactSystemFunctions.getMyRoleNames(),
        "B2BCustomer"
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp210732Visible =
      ReactSystemFunctions.contains(
        ReactSystemFunctions.getMyRoleNames(),
        "B2BCustomer"
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp861165Visible =
      ReactSystemFunctions.contains(
        ReactSystemFunctions.getMyRoleNames(),
        "B2BCustomer"
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp556414Visible =
      ReactSystemFunctions.contains(
        ReactSystemFunctions.getMyRoleNames(),
        "B2BCustomer"
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  LeftMenuComponent_620279_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenuComponent_63815_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "LeftMenu",
      "HomePageAdmin",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenuComponent_901672_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "LeftMenu",
      "AdminNotifManagement",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenuComponent_725468_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "LeftMenu",
      "ReportsFirstPage",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenuComponent_15857_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "LeftMenu",
      "HomePageCustomer",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenuComponent_101896_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "LeftMenu",
      "ProductListCollectionWebScreen",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenuComponent_368105_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "LeftMenu",
      "ProductListCollectionSelectedWebScreen",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenuComponent_340202_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "LeftMenu",
      "EndOfProductCollectionWeb",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenuComponent_553154_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "LeftMenu",
      "HizliStokWeb",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenuComponent_815895_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "LeftMenu",
      "ReportsCustomer",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenuComponent_957276_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "LeftMenu",
      "ProductBasketWeb",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenuComponent_210732_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "LeftMenu",
      "FavoritesListDesignWeb",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenuComponent_861165_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "LeftMenu",
      "CustomerNotifcationList",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenuComponent_556414_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "LeftMenu",
      "SocialMedia",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenuComponent_741736_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "LeftMenu",
      "Profile",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenuComponent_958804_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "LeftMenu",
      "Translate",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "452818",
      null,
      "bottom",
      "true",
      "100%",
      "15%",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenuComponent_734963_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {};

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "LeftMenu/LeftMenuComponent_734963_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetGuidanceDoc = result?.data.getGuidanceDoc;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.LeftMenuComponent_734963_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  LeftMenuComponent_734963_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.DownloadFile = await ReactSystemFunctions.downloadFile(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetGuidanceDoc !== undefined
          ? stateVars.GetGuidanceDoc?.length > 0
            ? stateVars.GetGuidanceDoc[0].doc
            : null
          : this.state.GetGuidanceDoc?.length > 0
          ? this.state.GetGuidanceDoc[0].doc
          : null
      ),
      ReactSystemFunctions.toString(
        this,
        stateVars.GetGuidanceDoc !== undefined
          ? stateVars.GetGuidanceDoc?.length > 0
            ? stateVars.GetGuidanceDoc[0].docName
            : null
          : this.state.GetGuidanceDoc?.length > 0
          ? this.state.GetGuidanceDoc[0].docName
          : null
      )
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenuComponent_20424_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);
    KuikaAppManager.increaseServerRequestCount();

    stateVars.Logout = await ReactSystemFunctions.logout();
    stateVars.tmpBoolResult = await ReactSystemFunctions.goToSignInActivity(
      this
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      452818,
    ] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.LeftMenuPageInit();
    }
  }
}
